import * as React from 'react';
import type { SVGProps } from 'react';
const SvgExternal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M16.6 2.996h-4.357a.775.775 0 0 0-.771.772c0 .424.348.772.771.772h2.481l-7.216 7.23a.767.767 0 0 0 0 1.09.77.77 0 0 0 1.09 0l7.23-7.216v2.48c0 .424.349.772.772.772a.775.775 0 0 0 .772-.772V3.768a.775.775 0 0 0-.772-.772" />
    <path d="M14.603 10.152a.775.775 0 0 0-.772.772v3.1c0 1-.816 1.8-1.8 1.8H6.358c-.998 0-1.8-.816-1.8-1.8V8.352c0-.998.817-1.8 1.8-1.8H9.46a.775.775 0 0 0 .771-.771.775.775 0 0 0-.771-.772H6.358A3.36 3.36 0 0 0 3 8.367v5.673a3.36 3.36 0 0 0 3.358 3.358h5.673a3.36 3.36 0 0 0 3.358-3.358v-3.117a.8.8 0 0 0-.786-.771" />
  </svg>
);
export default SvgExternal;
